import { styled } from "@fluentui/react";
import React from "react";
import { HomeBase } from "./Home.base";
import { getStyles } from "./Home.styles";
import { HomeProps, HomeStyleProps, HomeStyles } from "./Home.types";

export const Home: React.FunctionComponent<HomeProps> = styled<
  HomeProps,
  HomeStyleProps,
  HomeStyles
>(HomeBase, getStyles);
